// Shared spacing / shells for /v2/certs — matches Layerd-UI ssl-tls/*.html

import colors from "../../../../utils/colors";

export const CERTS_FAINT_GREY = "#FAFAFB";
/** Disabled row/card surface — matches SSL drawer --lsd-neutral-50 */
export const CERTS_MUTED_BG = "#FAFAFA";
/** Light indigo tint for active tab + card/section headings (theme primary[100]). */
export const CERTS_HEADING_BG = "rgb(245, 246, 254)";

/** Vertical rhythm between major blocks (hero, grids, tables, tab panels). */
export const CERTS_PAGE_SECTION_SPACING = 5.5;
/** Hero metric cards and encryption-mode ladder. */
export const CERTS_CARD_GRID_GAP = 3;
/** Two-column / multi-column card grids (timeline + posture, stat cards). */
export const CERTS_GRID_GAP = 3.5;
/** Stacked cards in the configuration main column and right rail. */
export const CERTS_INNER_STACK_SPACING = 3.5;
export const CERTS_SECTION_HEADER_MB = 3.5;
/** Page shell: header, tab row, and tab content. */
export const CERTS_PAGE_SHELL_SPACING = 5;
export const CERTS_CARD_PAD = 2.5; // theme spacing → 20px
export const CERTS_RIGHT_RAIL_WIDTH = 380;

/** Hero strip metric cards — Overview + Configuration tabs share these. */
export const certsHeroMetricCardSx = {
  minWidth: 0,
  height: "100%",
  minHeight: { xs: 0, lg: 120 },
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  p: CERTS_CARD_PAD,
  backgroundColor: "#fff",
  border: `1px solid ${colors.neutral[200]}`,
  borderRadius: "12px",
  boxShadow: "0 1px 2px rgba(17, 17, 17, 0.04)",
};

export const certsHeroMetricCardHighlightSx = {
  background: "linear-gradient(135deg, rgba(99, 113, 247, 0.18), rgba(99, 113, 247, 0.04))",
  border: "1px solid rgba(99, 113, 247, 0.30)",
};

/** .card-hd — light primary bar on bordered cards */
export const certsCardHeaderSx = {
  px: "20px",
  py: "16px",
  borderBottom: `1px solid ${colors.neutral[200]}`,
  backgroundColor: CERTS_HEADING_BG,
  gap: 1,
};

/** Panel / table title row */
export const certsPanelHeaderSx = {
  p: "14px 20px",
  borderBottom: `1px solid ${colors.neutral[200]}`,
  backgroundColor: CERTS_HEADING_BG,
};

/** .sect-head inside sectioned cards */
export const certsSectHeadSx = {
  p: "14px 20px 12px",
  borderBottom: `1px solid ${colors.neutral[200]}`,
  backgroundColor: CERTS_HEADING_BG,
  gap: 1.25,
};

export const certsSectIconSx = {
  width: 28,
  height: 28,
  borderRadius: "7px",
  backgroundColor: "#fff",
  border: `1px solid ${colors.neutral[200]}`,
  color: colors.neutral[700],
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

/** .setting-row */
export const certsSettingRowSx = {
  p: "16px 20px",
  gap: "14px",
  borderBottom: `1px solid ${colors.neutral[200]}`,
};

/** Inactive / dependent setting rows — theme disabled palette (no opacity wash). */
export const certsMutedSettingRowSx = {
  backgroundColor: CERTS_MUTED_BG,
  cursor: "not-allowed",
  "& .MuiTypography-root": { color: colors.neutral[500] },
  "& .Mui-disabled": {
    opacity: 1,
    WebkitTextFillColor: colors.neutral[500],
  },
  "& .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track": {
    backgroundColor: colors.neutral[200],
    borderColor: colors.neutral[200],
  },
  "& .MuiSwitch-switchBase.Mui-disabled.Mui-checked + .MuiSwitch-track": {
    backgroundColor: colors.neutral[300],
    borderColor: colors.neutral[300],
  },
  "& .MuiOutlinedInput-root.Mui-disabled": {
    backgroundColor: CERTS_MUTED_BG,
    color: colors.neutral[500],
    "& .MuiOutlinedInput-notchedOutline": { borderColor: colors.neutral[200] },
  },
};

/** .rec-item */
export const certsRecItemSx = {
  p: "14px 20px",
  gap: 1.625,
  borderBottom: `1px solid ${colors.neutral[200]}`,
};

export const certsCardShellSx = {
  backgroundColor: "#fff",
  border: `1px solid ${colors.neutral[200]}`,
  borderRadius: "12px",
  boxShadow: "0 1px 2px rgba(17, 17, 17, 0.04)",
  overflow: "hidden",
};

export const certsCardBodySx = { p: "20px" };

/** TLS posture checklist — vertical row list (Layerd-UI .check-list). */
export const certsPostureCheckListSx = {
  display: "flex",
  flexDirection: "column",
};

/** Single TLS posture row — label left, value + status right. */
export const certsPostureCheckRowSx = (warn = false, isLast = false) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 2,
  py: "11px",
  px: "18px",
  fontSize: 13,
  borderBottom: isLast ? 0 : `1px solid rgba(0, 0, 0, 0.08)`,
  transition: "background-color 120ms",
  ...(warn ? { backgroundColor: "rgba(242, 180, 41, 0.05)" } : {}),
  "&:hover": {
    backgroundColor: warn ? "rgba(242, 180, 41, 0.08)" : colors.neutral[50],
  },
});
